<ng-template #badgeTemplate>
  @if (item().view?.badge?.enable) {
    <span
      class="menu-top-bar__item-badge tw-absolute tw--translate-y-1/2 tw-inline-flex tw-items-center tw-max-w-full tw-overflow-hidden tw-pointer-events-none tw-leading-none"
      [class.with-label]="!!item().view?.title"
      [style.background-color]="_badgeBgColor()"
      [style.color]="_badgeTextColor()"
    >
      @if (item().view.badge.icon) {
        <img class="menu-top-bar__item-badge-icon tw-shrink-0 tw-object-contain" [src]="item().view.badge.icon" alt="" aria-hidden="true" />
      }
      @if (item().view.badge.title) {
        <span class="menu-top-bar__item-badge-text tw-truncate tw-min-w-0">{{ item().view.badge.title }}</span>
      }
    </span>
  }
</ng-template>

@if (_isButtonItem()) {
  <div
    [class.tw-flex]="displayMode === 'list'"
    [class.menu-top-bar__item-option--list]="displayMode === 'list'"
    [class.tw-w-full]="displayMode === 'list'"
  >
    <button
      mat-flat-button
      class="mat-button-theme-color button-item tw-relative"
      [ngClass]="{
        'deposit-button': inSubheader,
        'deposit_button_themed': inSubheader
      }"
      [class.register-btn]="item().action?.menu_type === MenuType.REGISTER"
      [class.login-btn]="item().action?.menu_type === MenuType.LOGIN"
      [class.tw-mx-auto]="displayMode === 'list'"
      (click)="itemClick.emit(item())"
    >
      @if (item().view?.image) {
        <img
          class="menu-top-bar__item-option-img tw-object-contain"
          [class.menu-top-bar__item-option-img--with-label]="!!item().view?.title"
          [src]="item().view.image"
          [alt]="item().view?.title || ''"
        />
      }

      <span class="tw-text-sm">{{ _buttonLabel() | translate }}</span>
      @if (item().view?.badge?.enable) {
        <span
          class="menu-top-bar__item-button-badge tw-absolute tw-right-0 tw--translate-y-1/2 tw-inline-flex tw-items-center tw-max-w-full tw-overflow-hidden tw-pointer-events-none tw-leading-none"
          [class.with-label]="!!item().view?.title"
          [style.background-color]="_badgeBgColor()"
          [style.color]="_badgeTextColor()"
        >
          @if (item().view.badge.icon) {
            <img
              class="menu-top-bar__item-button-badge-icon tw-shrink-0 tw-object-contain"
              [src]="item().view.badge.icon"
              alt=""
              aria-hidden="true"
            />
          }
          @if (item().view.badge.title) {
            <span class="menu-top-bar__item-button-badge-text tw-truncate tw-min-w-0">{{ item().view.badge.title }}</span>
          }
        </span>
      }
    </button>
  </div>
} @else if (item().identifier_type === IdentifierType.MENU_TYPE && item().action?.menu_type === MenuType.AUTH) {
  <ng-content></ng-content>
} @else if (item().identifier_type === IdentifierType.MENU_TYPE && item().action?.menu_type === MenuType.CONFIG) {
  <div
    class="menu-top-bar__item-option tw-flex tw-flex-row tw-items-center tw-self-stretch tw-gap-1 tw-cursor-pointer tw-relative"
    [class.tw-self-stretch]="displayMode === 'bar'"
    [class.menu-top-bar__item-option--list]="displayMode === 'list'"
    [class.tw-w-full]="displayMode === 'list'"
    [class.active-bar]="isActive && !(item().identifier_type === IdentifierType.MENU_TYPE && item().action?.menu_type === MenuType.LOGO)"
    (click)="itemClick.emit(item())"
  >
    @if (item().view?.image) {
      <img
        class="menu-top-bar__item-option-img tw-w-full tw-h-full tw-object-contain"
        [class.menu-top-bar__item-option-img--with-label]="!!item().view?.title"
        [src]="item().view.image"
        [alt]="item().view?.title || ''"
      />
    } @else {
      <mat-icon class="material-symbols-rounded  tw-mx-auto">settings</mat-icon>
    }
    @if (item().view?.title) {
      <span [class]="labelClass">{{ item().view.title }}</span>
    }
    <ng-container *ngTemplateOutlet="badgeTemplate"></ng-container>
  </div>
} @else if (item().identifier_type === IdentifierType.MENU_TYPE && item().action?.menu_type === MenuType.LANGUAGE) {
  <div
    class="menu-top-bar__item-option tw-flex tw-flex-row tw-items-center tw-self-stretch tw-gap-1 tw-cursor-pointer tw-relative"
    [class.tw-self-stretch]="displayMode === 'bar'"
    [class.menu-top-bar__item-option--list]="displayMode === 'list'"
    [class.tw-w-full]="displayMode === 'list'"
    [class.active-bar]="isActive && !(item().identifier_type === IdentifierType.MENU_TYPE && item().action?.menu_type === MenuType.LOGO)"
  >
    <app-language-button
      [customImage]="item().view?.image"
      [customLabel]="item().view?.title"
      [useLabel]="!!item().view?.title"
    ></app-language-button>
    <ng-container *ngTemplateOutlet="badgeTemplate"></ng-container>
  </div>
} @else if (item().identifier_type === IdentifierType.MENU_TYPE && item().action?.menu_type === MenuType.INBOX) {
  @if (showCrmButton) {
    <div
      class="menu-top-bar__item-option tw-flex tw-flex-row tw-items-center tw-self-stretch tw-gap-1 tw-relative"
      [class.tw-self-stretch]="displayMode === 'bar'"
      [class.menu-top-bar__item-option--list]="displayMode === 'list'"
      [class.tw-w-full]="displayMode === 'list'"
      [class.active-bar]="isActive && !(item().identifier_type === IdentifierType.MENU_TYPE && item().action?.menu_type === MenuType.LOGO)"
    >
      <app-crm-inbox-button [customImage]="item().view?.image" [customTitle]="item().view?.title"></app-crm-inbox-button>
      <ng-container *ngTemplateOutlet="badgeTemplate"></ng-container>
    </div>
  }
} @else if (item().identifier_type === IdentifierType.MENU_TYPE && item().action?.menu_type === MenuType.THEME) {
  <div
    class="menu-top-bar__item-option tw-flex tw-flex-row tw-items-center tw-self-stretch tw-gap-1 tw-cursor-pointer tw-relative"
    [class.tw-self-stretch]="displayMode === 'bar'"
    [class.menu-top-bar__item-option--list]="displayMode === 'list'"
    [class.tw-w-full]="displayMode === 'list'"
    [class.active-bar]="isActive && !(item().identifier_type === IdentifierType.MENU_TYPE && item().action?.menu_type === MenuType.LOGO)"
    (click)="$event.stopPropagation(); themeToggle.emit()"
  >
    @if (item().view?.image) {
      <img
        class="menu-top-bar__item-option-img tw-w-full tw-h-full tw-object-contain"
        [class.menu-top-bar__item-option-img--with-label]="!!item().view?.title"
        [src]="item().view.image"
        [alt]="item().view?.title || ''"
        [matTooltip]="showThemeTooltip ? ((isLightTheme ? 'GENERAL.DARK_THEME' : 'GENERAL.LIGHT_THEME') | translate) : ''"
      />
    } @else {
      <div
        class="theme-button tw-flex tw-items-center"
        [matTooltip]="showThemeTooltip ? ((isLightTheme ? 'GENERAL.DARK_THEME' : 'GENERAL.LIGHT_THEME') | translate) : ''"
      >
        <mat-icon class="material-symbols-rounded">{{ isLightTheme ? 'dark_mode' : 'light_mode' }}</mat-icon>
      </div>
    }
    @if (item().view?.title) {
      <span [class]="labelClass">{{ item().view.title }}</span>
    }
    <ng-container *ngTemplateOutlet="badgeTemplate"></ng-container>
  </div>
} @else if (item().identifier_type === IdentifierType.MENU_TYPE && item().action?.menu_type === MenuType.MENU) {
  @if (item().view?.image || item().view?.title) {
    <div
      class="menu-top-bar__item-option tw-flex tw-flex-row tw-items-center tw-self-stretch tw-gap-1 tw-cursor-pointer tw-relative"
      [class.tw-self-stretch]="displayMode === 'bar'"
      [class.menu-top-bar__item-option--list]="displayMode === 'list'"
      [class.tw-w-full]="displayMode === 'list'"
      [class.active-bar]="isActive && !(item().identifier_type === IdentifierType.MENU_TYPE && item().action?.menu_type === MenuType.LOGO)"
      (click)="itemClick.emit(item())"
    >
      @if (item().view?.image) {
        <img
          class="menu-top-bar__item-option-img tw-w-full tw-h-full tw-object-contain"
          [class.menu-top-bar__item-option-img--with-label]="!!item().view?.title"
          [src]="item().view.image"
          [alt]="item().view?.title || ''"
        />
      }
      @if (item().view?.title) {
        <span [class]="labelClass">{{ item().view.title }}</span>
      }
      <ng-container *ngTemplateOutlet="badgeTemplate"></ng-container>
    </div>
  } @else {
    <app-menu-toggle-button (toggled)="itemClick.emit(item())"></app-menu-toggle-button>
  }
} @else {
  @if (routerPath(); as path) {
    <a
      class="menu-top-bar__item-option tw-flex tw-flex-row tw-items-center tw-gap-1 tw-cursor-pointer tw-no-underline tw-text-inherit tw-relative"
      [class.tw-self-stretch]="displayMode === 'bar'"
      [class.menu-top-bar__item-option--list]="displayMode === 'list'"
      [class.tw-w-full]="displayMode === 'list'"
      [class.active-bar]="isActive && !(item().identifier_type === IdentifierType.MENU_TYPE && item().action?.menu_type === MenuType.LOGO)"
      [class.logo-item]="item().identifier_type === IdentifierType.MENU_TYPE && item().action?.menu_type === MenuType.LOGO"
      [class.active-hide]="item().view.image && !item().view.title"
      [aria-label]="item().action?.menu_type"
      [routerLink]="path"
      (click)="itemClick.emit(item())"
    >
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  } @else {
    <div
      class="menu-top-bar__item-option tw-flex tw-flex-row tw-items-center tw-gap-1 tw-cursor-pointer tw-relative"
      [class.tw-self-stretch]="displayMode === 'bar'"
      [class.menu-top-bar__item-option--list]="displayMode === 'list'"
      [class.tw-w-full]="displayMode === 'list'"
      [class.active-bar]="isActive && !(item().identifier_type === IdentifierType.MENU_TYPE && item().action?.menu_type === MenuType.LOGO)"
      [class.logo-item]="item().identifier_type === IdentifierType.MENU_TYPE && item().action?.menu_type === MenuType.LOGO"
      (click)="itemClick.emit(item())"
    >
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </div>
  }

  <ng-template #itemContent>
    @if (item().view?.image) {
      <img
        class="menu-top-bar__item-option-img tw-object-contain"
        [class.menu-top-bar__item-option-img--with-label]="!!item().view?.title"
        [src]="item().view.image"
        [alt]="item().view?.title || ''"
        loading="eager"
        fetchpriority="high"
      />
    }
    @if (item().view?.title) {
      <span [class]="labelClass">{{ item().view.title }}</span>
    }
    <ng-container *ngTemplateOutlet="badgeTemplate"></ng-container>
  </ng-template>
}
